/**
 * Created by tomers on 12/15/2014.
 */
define(function (require) {
    "use strict";

    var BaseModel = require("models/BaseModel");
    var Translator = require("i18n/translator");
    var TagItemsCollection = require("ui/tags-container/js/collections/TagItemsCollection");
    var _ = require("underscore");

    var TagsContainerModel = BaseModel.extend({
        defaults: function(){
            return {
                enabled: true,
                maxShownLines: 0,
                tagCreationEnabled: true,
                errorText: null,
                inlineErrorText: Translator.translate("LEUIComponents.errors.tagscontainer.viewValidation.registerChanges"),
                tagMaxWidth: "100%",
                itemsComparator: false,
                placeholder: "",
                separator: "",
                closeable: true,
                items: new TagItemsCollection()
            };
        },

        getEnabled: function() {
            return this.get("enabled");
        },
        setEnabled: function(enabled) {
            this.set("enabled", enabled);
        },
        isEnabled: function() {
            return (this.getEnabled() === true);
        },

        getMaxShownLines: function() {
            return this.get("maxShownLines");
        },
        setMaxShownLines: function(maxShownLines) {
            this.set("maxShownLines", maxShownLines);
        },
        isUnlimitedShownLines: function() {
            return !(this.getMaxShownLines());
        },

        getTagCreationEnabled: function() {
            return this.get("tagCreationEnabled");
        },
        setTagCreationEnabled: function(tagCreationEnabled) {
            this.set("tagCreationEnabled", tagCreationEnabled);
        },
        isTagCreationEnabled: function() {
            return (this.getTagCreationEnabled() === true);
        },

        getTagMaxWidth: function() {
            return this.get("tagMaxWidth");
        },
        setTagMaxWidth: function(tagMaxWidth) {
            this.set("tagMaxWidth", tagMaxWidth);
        },

        getInlineErrorText: function() {
            return this.get("inlineErrorText");
        },
        setInlineErrorText: function(inlineErrorText) {
            this.set("inlineErrorText", inlineErrorText);
        },

        getInlineErrorBubbleZIndex: function() {
            return this.get("inlineErrorBubbleZIndex");
        },
        setInlineErrorBubbleZIndex: function(inlineErrorBubbleZIndex) {
            this.set("inlineErrorBubbleZIndex", inlineErrorBubbleZIndex);
        },

        getErrorText: function() {
            return this.get("errorText");
        },
        setErrorText: function(errorText) {
            this.set("errorText", errorText);
        },

        getPlaceholder: function() {
            return this.get("placeholder");
        },
        setPlaceholder: function(enabled) {
            this.set("placeholder", enabled);
        },

        getCloseable: function() {
            return this.get("closeable");
        },
        setCloseable: function(closeable) {
            this.set("closeable", closeable);
        },
        isCloseable: function() {
            return (this.getCloseable() === true);
        },

        getSeparator: function() {
            return this.get("separator");
        },
        setSeparator: function(separator) {
            this.set("separator", separator);
        },

        getTooltipAlign: function() {
            return this.get("tooltipAlign");
        },
        setTooltipAlign: function(tooltipAlign) {
            this.set("tooltipAlign", tooltipAlign);
        },

        getItemsComparator: function() {
            return this.get("itemsComparator");
        },
        setItemsComparator: function(comparator) {
            this.set("itemsComparator", comparator);

            this.getItems().setComparator(comparator);
            if (comparator !== false) {
                this.getItems().sort();
            }
        },

        setItems: function(items) {
            if (items && _.isArray(items)) {
                // set the actions on each item
                _.each(items, _.bind(function(item, index) {
                    items[index].closeable = _.has(item, "closeable") ? item.closeable : this.getCloseable();
                    items[index].separator = _.has(item, "separator") ? item.separator : this.getSeparator();
                }, this));


                this.getItems().reset(items);
            }
        },
        getItems: function() {
            return this.get("items");
        },
        addItem: function(item) {
            item.closeable = _.has(item, "closeable") ? item.closeable : this.getCloseable();
            item.separator = _.has(item, "separator") ? item.separator : this.getSeparator();

            this.getItems().add(item, {merge:true});
        },
        removeItem: function(itemId) {
            this.getItems().remove(itemId);
        },

        getItemModel: function(itemId) {
            return this.getItems().get(itemId);
        }

    });

    return TagsContainerModel;
});


